//import RequestAbstract from "./RequestAbstract";
import RequestCache from "./RequestCache";

export default class PaymentWay extends RequestCache {
    get cacheInterval() {
        return 7;
    }
    
    get link() {
        return this.links.paymentWay;
    }

    async getAll() {
        return await this.getAllFiltered([]);
    }
}
